import { Fragment, ReactElement } from 'react';
import StepFromAnsc from 'civil-status/pages/step-from-ansc';
import Breadcrumbs, { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

interface EditNotificationsSharedProps {
  baseUrl?: string;
  items?: BreadcrumbItem[];
}

const EditNotificationsShared = ({
  items,
  baseUrl,
}: EditNotificationsSharedProps): ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={items || []} />
      <StepFromAnsc isEditAcquisitionNotifications isWithoutBreadcrumbs baseUrl={baseUrl} />
    </Fragment>
  );
};

EditNotificationsShared.displayName = 'Edit Notifications shared component';

export default EditNotificationsShared;
